import { render, staticRenderFns } from "./ManageSettlementsInDefault.vue?vue&type=template&id=1ac45148&scoped=true"
import script from "./ManageSettlementsInDefault.vue?vue&type=script&lang=js"
export * from "./ManageSettlementsInDefault.vue?vue&type=script&lang=js"
import style0 from "./ManageSettlementsInDefault.vue?vue&type=style&index=0&id=1ac45148&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac45148",
  null
  
)

export default component.exports